"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EOrganizationStatus = void 0;
var EOrganizationStatus;
(function (EOrganizationStatus) {
    EOrganizationStatus["ACTIVE"] = "active";
    EOrganizationStatus["INACTIVE"] = "inactive";
})(EOrganizationStatus || (exports.EOrganizationStatus = EOrganizationStatus = {}));
